import React from 'react'
import { InputAdornment, TextField } from '@mui/material'
import { type FormikProps } from 'formik'
import { FormikFieldErrors } from './FormikFieldErrors'

interface TextFieldProps {
  formikProps: FormikProps<any>
  type: 'number' | 'text' | 'password' | 'email'
  fieldName: string
  label: string
  locked: boolean

  adornment?: string | null
  multiline?: boolean
}

const FormikTextField: React.FC<TextFieldProps> = ({ formikProps, fieldName, label, type, locked, adornment = null, multiline = false }: TextFieldProps) => {
  const formikErrors = new FormikFieldErrors(formikProps)

  return (
    (adornment !== null
      ? <TextField
      label={label}
      type={type}
      variant="outlined"
      sx={{ width: '100%' }}
      placeholder={label}

      {...formikProps.getFieldProps(fieldName)}

      error={formikErrors.fieldInError(fieldName)}
      helperText={formikErrors.getError(fieldName)}
      disabled={locked}
      InputProps={{ endAdornment: <InputAdornment position="end">{adornment}</InputAdornment> }}
    />
      : <TextField
          label={label}
          type={type}
          variant="outlined"
          sx={{ width: '100%' }}
          placeholder={label}

          multiline={multiline}
          maxRows={10}

          {...formikProps.getFieldProps(fieldName)}

          error={formikErrors.fieldInError(fieldName)}
          helperText={formikErrors.getError(fieldName)}
          disabled={locked}
        />
    )
  )
}

export default FormikTextField
